(function() {
  angular
    .module('specsguardApp')
    .directive('sgTableColumnFilter', sgTableColumnFilter);

  sgTableColumnFilter.$inject = [];

  function sgTableColumnFilter () {
    return {
      restrict: 'E',
      templateUrl: 'app-legacy/components/sg-mat-table/sg-table-column-filter/sg-table-column-filter.html',
    };
  };
})();
